import { Suspense } from 'react';
import useDynamicRemote from '../utils/hooks/useDynamicRemote';

function RemoteLoader<Props extends object>({
  remoteName,
  remoteUrl,
  moduleName,
  props,
}: {
  remoteName: string;
  remoteUrl: string;
  moduleName: string;
  props: Props;
}) {
  const state = useDynamicRemote<Props>(remoteName, remoteUrl, moduleName);

  if (state.status === 'loading') return <div>Chargement...</div>;
  if (state.status === 'error') {
    console.error('Error loading remote module', state.details);
    return (
      <div>
        <p>Chargement impossible !</p>
        <p>Veuillez vérifier l'existence du module distant.</p>
      </div>
    );
  }

  return (
    <Suspense fallback={<div>Chargement du composant distant...</div>}>
      <state.Component {...props} />
    </Suspense>
  );
}

export default RemoteLoader;
